import { styled } from "@mui/material/styles";
import {
  Table,
  TableCell,
  tableCellClasses,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  TableContainer,
  Box,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#f0f0f0",
    whiteSpace: "nowrap",
  },
}));

export default function UseTable(
  tblData,
  headCells,
  filterFn,
  fetchData,
  rowsCount,
  pageSize,
  pageIndex
) {
  const pages = [10, 25, 35, 45];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pages[0]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [internalData, setInternalData] = useState(tblData);

  useEffect(() => {
    setInternalData(tblData); // Update internal data when tblData prop changes
    setPage(pageIndex || 0); // Update internal page if prop changes
    setRowsPerPage(pageSize || pages[0]); // Update internal rowsPerPage if prop changes
}, [tblData, pageIndex, pageSize]);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rowsCount) : 0;
  const TblContainer = (props) => (
    <TableContainer component={Paper}>
      <Table>{props.children}</Table>
    </TableContainer>
  );

  const handleSortRequest = (cellId) => {
    const isAsc = orderBy === cellId && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(cellId);
  };

  const TblHeader = (props) => {
    return (
      <TableHead size="small">
        <TableRow size="small">
          {headCells.map((item) => (
            <StyledTableCell
              key={item.id}
              sortDirection={orderBy === item.id ? order : false}
              align={item.align || "left"}
              size="small"
            >
              {!item.disableSorting ? (
                <Typography
                  size="small"
                  variant="overline"
                  fontWeight="bold"
                  display="block"
                  gutterBottom
                >
                  {item.label}{" "}
                </Typography>
              ) : (
                <TableSortLabel
                  active={false}
                  direction={orderBy === item.id ? order : "asc"}
                  size="small"
                  onClick={() => handleSortRequest(item.id)}
                >
                  <Typography
                    fontWeight="bold"
                    size="small"
                    variant="overline"
                    display="block"
                    gutterBottom
                  >
                    {item.label}{" "}
                  </Typography>
                </TableSortLabel>
              )}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchData(rowsPerPage, newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    fetchData(parseInt(event.target.value, 10), 0);
  };

  const TblPagination = () => (
    <TablePagination
      component="div"
      page={pageIndex}
      rowsPerPageOptions={pages}
      rowsPerPage={rowsPerPage}
      count={rowsCount}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const tblDataAfterPaginationAndSorting = () => {
    return stableSort(filterFn.fn(tblData), getComparator(order, orderBy)); //.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  };

  return {
    TblContainer,
    TblHeader,
    TblPagination,
    tblDataAfterPaginationAndSorting,
    emptyRows,
  };
}
